import { AfterContentInit, Component, Input, OnInit, ViewChild } from '@angular/core';
import {
  OPERATION, SupplierAddressPropertyValues, TabPermissions,
  SupplierEntityPropertyValues, SupplierAddress, SupplierDocumentPropertyValues,
  SupplierPropertyValue, Supplier, SupplierDocument, SupplierContactPropertyValue
} from 'app/profile/models/supplier.model';
import { MatDialog} from '@angular/material/dialog';
import { PageEvent} from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AddressDialogComponent } from './address-dialog/address-dialog.component';
import { SupplierState } from 'app/profile/store/state/supplierstate.state';
import { Store, select } from '@ngrx/store';
import {
  SelectSupplierAddressList, SelectCountries,
  SelectTabPermissions, SelectSupplierEntityList, SelectSupplierDocumentList, SelectSupplierMfgAddressList,
  getAvailableConfiguration, SelectSupplierWarehouseAddressList,
  SelectSupplierPickupWarehouseAddressList, SelectSupplierAddressTypes, SelectEventData, getSupplierExternalPartnerList, SelectValidationTask, SelectCurrentUser, SelectSupplierContactList, getGeneralSettings
} from 'app/profile/store/app.selector';
import { GetCountryList, GetSupplierAddressContactTypes, PostEvent } from 'app/profile/store/app.actions';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from 'app/profile/services/common.service';
import { BehaviorSubject, Observable, combineLatest, forkJoin } from 'rxjs';
import { deepfind, GetFullAddress, getNestedNode, GetFullAddressDetails, GetCountryDetails } from 'app/shared/utils/utils';
import { Country, AddressType } from 'app/profile/models/masterdata.model';
import {
  GetSupplierAddressListByCode, GetTabPermissions,
  DeleteSupplierAddress, GetSupplierDocumentsListByCode, ClearSupplierDetailsByCode, GetSupplierMfgAddressListByCode,
  GetSupplierWarehouseAddressListByCode, AddWarehouseSupplierAddress, EditWarehouseSupplierAddress,
  DeleteWarehouseSupplierAddress, GetSupplierPickupWarehouseAddressListByCode, GetSupplierEntityListByCode, GetSupplierExernalPartnerList, GetValidationTaskByCode, GetSupplierProfileCurrentUser
} from 'app/profile/store/actions/supplierstate.action';
import { IncrementLoaderCount, DecrementLoaderCount } from 'app/shared/store/actions';
import { AddressSuggestionComponent } from 'app/shared/components/address-suggestion/address-suggestion.component';
import { SupplierStateService } from 'app/profile/services/supplierstate.service';
import { SupplierWarehouse, PickupWarehouse } from 'app/profile/models/profile.model';
import { ProfileService } from 'app/profile/services/profile.service';
import { TslDialog, TslPagination, TslTabChangeEvent } from '@tesla/ng-tds';
import { StatusEnum, Status } from 'app/profile/models/state.model';
import { StateService } from 'app/profile/services/state.service';
import { FileUploadService } from '../../../../common/services/fileUpload.service';
import { ValidationTask } from 'app/profile/models/people.model';
import { SupplierContactMap, UserDetails } from 'app/profile/models/user.model';
import { TabHistoryComponent } from '../../tab-history/tab-history.component';
import { BaseComponent } from '../../base.component';
import { I18nService } from '../../../../shared/services/i18n.service';
import { switchMap } from 'rxjs/operators';
import { AddressLinkDialogComponent } from './address-link-dialog/address-link-dialog.component';
import { AddressDelinkDialogComponent } from './address-delink-dialog/address-delink-dialog.component';
import { GeneralSettings } from 'app/profile/models/generic.model';
import * as FileSaver from 'file-saver';

@Component({
  selector: 'app-address-grid',
  templateUrl: './address-grid.component.html',
  styleUrls: ['./address-grid.component.scss']
})
export class AddressGridComponent extends BaseComponent implements OnInit, AfterContentInit {
  currentPageSource: BehaviorSubject<Array<any>> = new BehaviorSubject([]);
  SupplierCode: string;
  supplierAddressList: SupplierAddressPropertyValues[] = [];
  countryList: Country[];
  entityMap: SupplierEntityPropertyValues[];
  documentsList: SupplierDocumentPropertyValues[];
  obWarehouses$: SupplierWarehouse[];
  obPickupWarehouses$: PickupWarehouse[];
  addressData: (SupplierAddressPropertyValues | any)[] = [];

  tabPermissions: TabPermissions;
  availableFields: string[] = [];

  filterSelection = "RemitTo";
  @Input() helpUrl: string="";
  @ViewChild('paginationControl', { static: false }) paginationControl: TslPagination;

  addressModifiedSupplier: SupplierPropertyValue = new SupplierPropertyValue();
  files: File[] = [];
  // grid properties
  pageSizeOptions: number[] = [15, 25, 50, 100, 250];
  total = 0;
  displayedColumns = ["address", "comment", "documents", "actions"];
  addressPurpose: AddressType[] = [];
  validationTask: ValidationTask = null;
  hasDraftValidationTask: boolean = false;
  hasPendingValidationTask: boolean = false;
  primaryEmail: string = null;
  userDetails: UserDetails = null;
  defaultTabIndex: number = 0;
  code: string;
  externalPartners: any;
  pickuphouseAddressList;
  isPrimary: boolean = false;
  isProfileAdmin: boolean = false;
  showLinkDelink: boolean = false;
  contactEmails: string[] = [];
  settings: GeneralSettings;
  showManufacturingAddressCMTUrl: boolean;
  manufacturingAddresscmtUrl: string;
  
  constructor(private matDialog: MatDialog,
    private dialog: TslDialog,
    private store: Store<SupplierState>,
    private router: Router,
    private route: ActivatedRoute,
    private translateService: I18nService,
    private commonService: CommonService,
    private supplierStateService: SupplierStateService,
    private service: ProfileService,
    private stateService: StateService,
    private snackBar: MatSnackBar) {
    super();
  }

  ngAfterContentInit() {
    this.route.params.subscribe(params => {
      // navigate to internal tab
      if (params["tab"]) {
        this.setInternalTab(params["tab"].toLowerCase());
      }
    });

  }

  ngOnInit() {
    this.store.dispatch(new GetSupplierProfileCurrentUser());
    this.route.parent.params.subscribe(p => {
      this.code = p.code;
      //this.router.navigate([`../${this.code}/Address/remitto`]);

      // this.setInternalTab('remitto')
    })

    combineLatest(
      [this.store.pipe(select(SelectCurrentUser)),
      this.route.parent.params])
      .subscribe(([result, params]) => {
        if (params["code"]) {
          this.SupplierCode = this.commonService.getSupplierCode(params["code"]);
        }
        if (result) {
          this.userDetails = result;
        }

        if (this.SupplierCode && this.userDetails) {
          this.loadComponentData(true);
          this.store.select(getGeneralSettings).subscribe(res => {
            this.settings = res;
            if (res) {
                this.helpUrl = this.settings.settings.addressHelpUrl;
                this.showManufacturingAddressCMTUrl = this.settings.settings.showManufacturingAddressCMTUrl === "1";
                this.manufacturingAddresscmtUrl = this.settings.settings.manufacturingAddresscmtUrl;
            }
        });
        }
      });
  }
  setInternalTab(tab: string): void {
    // setTimeout(() =>{
    const tabNames = ['remitto', 'manufacturing', 'supplier-ship-from-address'];
    this.defaultTabIndex = tabNames.findIndex(x => x === tab);

    //});
  }
  setContactColumn() {
    if (this.filterSelection === 'Supplier Ship From Address') {
      this.displayedColumns.splice(3, 0, 'contacts');
    } else {
      this.displayedColumns = this.displayedColumns.filter(x => x !== 'contacts');
    }
  }
  loadComponentData(isReload: boolean = false) {
    if (this.SupplierCode !== null) {
      if (isReload) {
        this.store.dispatch(new ClearSupplierDetailsByCode(this.SupplierCode));
      }
      this.store.select((getAvailableConfiguration)).subscribe((result: string[]) => {
        this.availableFields = result;

        this.store.dispatch(new GetSupplierAddressContactTypes());
        this.store.dispatch(new GetCountryList());
        this.store.dispatch(new GetTabPermissions(this.SupplierCode));
        if (this.availableFields.includes("Add Address - Remit To") || this.availableFields.includes("Add Address - Manufacturing")) {
          this.store.dispatch(new GetSupplierAddressListByCode(this.SupplierCode));
          this.store.dispatch(new GetSupplierDocumentsListByCode(this.SupplierCode));
          this.store.dispatch(new GetSupplierMfgAddressListByCode(this.SupplierCode));
        }

        if (this.availableFields.includes("Add Non-Tesla Warehouse Address")) {
          this.store.dispatch(new GetSupplierWarehouseAddressListByCode(this.SupplierCode));
        }
        if (this.availableFields.includes("Add Address - Tesla Pickup")) {
          this.store.dispatch(new GetSupplierPickupWarehouseAddressListByCode(this.SupplierCode));
        }

        if (this.availableFields.includes("Add Address - Tesla Shipfrom")) {
          this.store.dispatch(new GetSupplierExernalPartnerList(this.SupplierCode));
        }


        this.store.dispatch(new GetSupplierEntityListByCode(this.SupplierCode));
        this.store.dispatch(new GetValidationTaskByCode(this.SupplierCode));

        this.PrimaryContactDocument(this.store, this.router, this.SupplierCode, false);
        this.store.pipe(select(SelectCountries)).subscribe(x => this.countryList = x);
        this.store.pipe(select(SelectTabPermissions)).subscribe(tabPermissions => this.tabPermissions = tabPermissions);
        this.store.select(SelectSupplierEntityList).subscribe(entityMap => {
          this.entityMap = entityMap;
        });
        this.store.select((SelectValidationTask)).subscribe((result: ValidationTask) => {
          if (result && (result.statusId === 1 || result.statusId === 2)) {
            this.validationTask = result;
            this.hasDraftValidationTask = this.validationTask.statusId === 1;
            this.hasPendingValidationTask = this.validationTask.statusId === 2;
            if (this.hasPendingValidationTask) {
              this.primaryEmail = this.validationTask.email;
            }
          }
        });

        this.store.pipe(select(SelectCurrentUser)).subscribe(result => {
          if (result) {
            this.userDetails = result;
            if (this.userDetails) {
              if (this.userDetails.supplierContact && this.userDetails.supplierContact.supplierMaps) {
                let supplierMap: SupplierContactMap = this.userDetails.supplierContact.supplierMaps.find(x => x.supplierCode == this.SupplierCode) as SupplierContactMap;
                this.isPrimary = supplierMap.userRoles.some(x => x.role.toLocaleLowerCase() === "primary");
                this.isProfileAdmin = supplierMap.userRoles.some(x => x.role.toLocaleLowerCase() === "profile admin");
              }

              this.showLinkDelink = this.isPrimary || this.isProfileAdmin;
            }
          }
        });

        this.store.select(SelectSupplierAddressTypes).subscribe(items => {
          if (items) {
            this.addressPurpose = items.sort((a, b) => a.id - b.id);
          }
        });

        combineLatest([this.store.select(SelectSupplierAddressList),
        this.store.select(SelectSupplierDocumentList),
        this.store.select(SelectSupplierWarehouseAddressList),
        this.store.select(SelectSupplierPickupWarehouseAddressList),
        this.store.select(SelectSupplierMfgAddressList),
        this.store.select(getSupplierExternalPartnerList)
        ]
        )
          .subscribe(([addressList, documentList, warehouseAddressList, pickuphouseAddressList, masterManufacturingAddresses, externalPartnerList]) => {
            this.supplierAddressList = [];
            if (addressList) {
              if (this.availableFields.includes("Add Address - Remit To")) {
                let remitToAddressList = addressList.filter(x => x && x.types && x.types.newValue && x.types.newValue.includes("RemitTo"));
                this.supplierAddressList.unshift(...remitToAddressList);
              }
              if (this.availableFields.includes("Add Address - Manufacturing")) {
                let manufacturingAddressList = addressList.filter(x => x && x.types && x.types.newValue && x.types.newValue.includes("Manufacturing"));
                this.supplierAddressList.unshift(...manufacturingAddressList);
              }
            }

            if (warehouseAddressList && warehouseAddressList.length > 0) {
              this.supplierAddressList.unshift(...warehouseAddressList);
            }

            if (pickuphouseAddressList && pickuphouseAddressList.length > 0) {

              this.pickuphouseAddressList = pickuphouseAddressList;
              this.supplierAddressList.unshift(...pickuphouseAddressList);
            }

            if (masterManufacturingAddresses && masterManufacturingAddresses.length > 0) {
              this.supplierAddressList.unshift(...masterManufacturingAddresses)
            }

            if (externalPartnerList && externalPartnerList.length > 0) {
              this.supplierAddressList.unshift(...externalPartnerList);
            }

            if (documentList && documentList.length > 0) {
              this.documentsList = new Array(...documentList);
            }
            this.onLoadAddressGrouping();
          });
      });

      this.store.select(SelectSupplierContactList).subscribe((contacts: SupplierContactPropertyValue[]) => {
        if (contacts) {
          this.contactEmails = contacts.map(contact => contact.email.newValue);
        }
      });
    }
  }

  pageChange(pageChange: PageEvent) {
    const { previousPageIndex, pageSize, pageIndex } = pageChange;
    const tempList = JSON.parse(JSON.stringify(this.addressData));
    this.addressData = this.addressData.filter(x => x.name === this.filterSelection || (x.types && x.types.newValue[0] === this.filterSelection));
    if (previousPageIndex === pageIndex) {
      this.currentPageSource.next(
        [...this.addressData].slice(0, pageSize)
      );
    } else {
      const from = pageIndex * pageSize;
      const to = from + pageSize;
      this.currentPageSource.next(
        [...this.addressData].slice(from, to)
      );
    }
    
    this.addressData = JSON.parse(JSON.stringify(tempList));
  }

  loadData() {
    this.currentPageSource.next([...this.addressData].slice(0, 15));
    this.total = this.addressData.length;
  }

  openDialog(dataItem: SupplierAddressPropertyValues): void {
    if (dataItem && dataItem.types.newValue[0] === 'External Partner') {
      this.router.navigate([`${this.SupplierCode}`, { tab: 'contacts', internal: 'external' }], { skipLocationChange: true });
    }

    if (dataItem == null || this.addressPurpose.find(x => x.name === dataItem.types.newValue[0])) {
      const hasManufacturing: boolean = this.supplierAddressList.some(x => x.types.newValue[0] === 'Manufacturing');

      const dialogRef = this.matDialog.open(AddressDialogComponent, {
        width: '68%',
        minWidth: '630px',
        data: { dataItem: dataItem, selectedAddress: this.filterSelection, supplierCode: this.SupplierCode, alreadyHasManufacturing: hasManufacturing, hasPendingValidationTask: (this.hasDraftValidationTask || this.hasPendingValidationTask) }
      });

      dialogRef.afterClosed().subscribe((x: any[]) => {
        if (x && x.length > 0) {
          let address: SupplierAddressPropertyValues = x[0] as SupplierAddressPropertyValues;
          let docList: SupplierDocumentPropertyValues[];
          if (x.length > 1) {
            docList = x[1] as SupplierDocumentPropertyValues[];
          }
          this.processSubmit(dataItem, address, docList);
        }
      });
    }
  }

  openLinkDialog(element: SupplierAddressPropertyValues): void {
    const dialogRef = this.matDialog.open(AddressLinkDialogComponent, {
      width: '68%',
      minWidth: '630px',
      data: { selectedAddress: this.filterSelection, warehouseAddress: element, supplierCode: this.SupplierCode }
    });
    dialogRef.afterClosed().subscribe(res => {
      if (res === true) {

        this.store.dispatch(new GetSupplierPickupWarehouseAddressListByCode(this.SupplierCode, true));
        this.store.select(SelectSupplierPickupWarehouseAddressList).subscribe(pickupWareHouseAddress => {
          this.addressData = this.addressData.filter(x => !(x.name === this.filterSelection || (x.types && x.types.newValue[0] === this.filterSelection)));
          this.addressData.unshift(...pickupWareHouseAddress);
          this.filterAddress();
        });
      }
    })

  }

  openUnlinkDialog(element: SupplierAddressPropertyValues): void {
    const dialogRef = this.matDialog.open(AddressDelinkDialogComponent, {
      width: '68%',
      minWidth: '630px',
      data: { selectedAddress: this.filterSelection, warehouseAddress: element, supplierCode: this.SupplierCode }
    });

    dialogRef.afterClosed().subscribe(res => {
      if (res === true) {
        this.store.dispatch(new GetSupplierPickupWarehouseAddressListByCode(this.SupplierCode, true));
        this.store.select(SelectSupplierPickupWarehouseAddressList).subscribe(pickupWareHouseAddress => {
          this.addressData = this.addressData.filter(x => !(x.name === this.filterSelection || (x.types && x.types.newValue[0] === this.filterSelection)));
          this.addressData.unshift(...pickupWareHouseAddress);
          this.filterAddress();
        });
      }
    })

  }

  deleteItem(item: SupplierAddressPropertyValues) {
    if (this.userDetails == null || this.userDetails.isTeslaUser == true) {
      this.snackBar.open(this.translateService.get("Invalid action."), null, {
        duration: 5000,
        verticalPosition: 'top',
        panelClass: ['red-snackbar']
      });
      return;
    }
    if (!item) {
      return;
    }

    if (item.types.newValue[0] === 'External Partner') {
      this.router.navigate([`${this.SupplierCode}`, { tab: 'contacts', internal: 'external' }], { skipLocationChange: true });
    }

    const dialogRef = this.dialog.confirm(this.translateService.get('Confirm'), this.translateService.get('Are you sure you want to delete this address?'));
    dialogRef.afterClosed().subscribe(x => {
      if (x) {
        if (item.types.newValue[0] !== 'Off-Site Part Storage Locations') {
          if (this.entityMap.findIndex(entity => deepfind(entity.addressID, 'newValue') &&
            (deepfind(entity.addressID, 'newValue') === deepfind(item.id, 'newValue') ||
              deepfind(entity.addressID, 'newValue') === deepfind(item.stageID, 'newValue'))) > -1) {
            this.dialog.alert(this.translateService.get('Error'), this.translateService.get('You cannot delete an address that is active and in use. Please email vendorchanges@tesla.com for making changes!'));
          } else {
            if (item.id) {
              item.operation.newValue = OPERATION.DELETE;
              // Post Event call - delete
              let addressDocList = this.documentsList.filter(x => item.documents.newValue.includes(x.documentID.newValue));
              addressDocList.forEach(x => {
                x.operation.newValue = OPERATION.DELETE;
              });
              this.processAddressChanges(item, addressDocList);
              this.store.select(SelectEventData).subscribe((evt: any) => {
                if (evt) {
                  this.loadComponentData(true);
                }
              });
            } else {
              this.store.dispatch(new DeleteSupplierAddress(this.supplierAddressList.indexOf(item)));
            }
          }
        } else {
          // convert the model back to supplier warehouse
          const dataItem = this.addresstoWarehouseModel(item);
          this.onRemoveWarehouse(dataItem, item);
        }
      }
    });
  }

  processSubmit(dataItem: SupplierAddressPropertyValues, newAddress: SupplierAddressPropertyValues, docList: SupplierDocumentPropertyValues[]) {
    if (dataItem) {
      if (newAddress && newAddress.types.newValue[0] === 'Off-Site Part Storage Locations') {
        this.postWarehouseAddress(dataItem, newAddress);
      } else {
        if (dataItem.id) {
          newAddress.operation.newValue = OPERATION.UPDATE;
        }
        // Post Event call - update
        this.processAddressChanges(newAddress, docList);
      }
    } else {
      if (newAddress && newAddress.types.newValue[0] === 'Off-Site Part Storage Locations') {
        this.postWarehouseAddress(null, newAddress);
      } else {
        // Post Event call - create
        newAddress.operation.newValue = OPERATION.CREATE;
        this.processAddressChanges(newAddress, docList);
      }
    }
  }

  postWarehouseAddress(dataItem: SupplierAddressPropertyValues, newAddress: SupplierAddressPropertyValues) {
    // other address
    const item = this.addresstoWarehouseModel(newAddress);

    if (item.id === undefined || item.id === 0) {
      // create
      this.service.postWarehouse(this.SupplierCode, item)
        .subscribe(ele => {
          this.stateService.currentStatus.next(new Status(StatusEnum.Success));
          if (ele) {
            this.loadComponentData(true);
          }
        });
    } else {
      // save to api
      this.service.putWarehouse(this.SupplierCode, item)
        .subscribe(ele => {
          this.stateService.currentStatus.next(new Status(StatusEnum.Success));
          if (ele) {
            this.loadComponentData(true);
          }
        });
    }
  }

  getFullAddress(address: SupplierAddressPropertyValues) {
    if (address) {
      return GetFullAddress(address, 'newValue');
    }
  }

  getFullAddressDetails(address: SupplierAddressPropertyValues) {
    if (address) {
      return GetFullAddressDetails(address, 'newValue');
    }
  }

  getCountryDetails(address: SupplierAddressPropertyValues) {
    if (address) {
      return GetCountryDetails(address, 'newValue', this.countryList);
    }
  }

  canChangeItem(dataItem: SupplierAddressPropertyValues) {
    if (!this.userDetails || this.isPCFValidationInReview) {
      return false;
    }

    let allowChangeItem = false;
    if (dataItem &&
      (!(dataItem.stageID && dataItem.stageID.newValue) || (dataItem.isTouched && (dataItem.stageID && dataItem.stageID.newValue)))) {
      if (!dataItem.types.newValue.includes('Supplier Ship From Address')) {
        const keys = Object.keys(dataItem);
        allowChangeItem = keys.some(key => deepfind(dataItem, `${key}.permission`) === "ReadWrite");
      }

      // If there is a validation task pending in draft or supplier action pending stage then 
      // don't allow edit and delete operation.
      if (allowChangeItem === true && (this.hasDraftValidationTask || this.hasPendingValidationTask) && dataItem.types.newValue.includes('RemitTo')) {
        allowChangeItem = false;
      }

      if (dataItem && dataItem.addressType && dataItem.addressType.toLowerCase() === 'manufacturing') {
        allowChangeItem = false;
      }
    }
    return allowChangeItem;
  }

  getDocument(documentId: string) {
    if (this.documentsList && documentId) {
      return this.documentsList.find(doc => getNestedNode(['documentID', 'newValue'], doc) === documentId ||
        getNestedNode(['stageID', 'newValue'], doc) === documentId);
    }
  }

  downloadFiles(documentId: string, version: string = '1') {
    const doc: SupplierDocumentPropertyValues = this.getDocument(documentId);
    if (documentId && version && doc) {
      this.supplierStateService.downloadFile(this.SupplierCode, doc.referenceSystem.newValue ? doc.referenceSystem.newValue : 'DMS', documentId, doc.documentVersion.newValue).subscribe(file => {
        const fileName: string = doc.fileName.newValue;
        if (file) {
          FileSaver.saveAs(file, fileName);
        }  else {
          const link = document.createElement('a');
          // Browsers that support HTML5 download attribute
          if (link.download !== undefined) {
            const url = URL.createObjectURL(file);
            link.setAttribute('href', url);
            link.setAttribute('download', fileName);
            link.style.visibility = 'hidden';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }
        }
      });
    }
  }

  onRemoveWarehouse(warehouse: SupplierWarehouse, item: SupplierAddressPropertyValues): void {
    this.service.deleteWarehouse(this.SupplierCode, warehouse.id)
      .subscribe(ele => {
        this.stateService.currentStatus.next(new Status(StatusEnum.Success));
        this.loadComponentData(true);
      });
  }

  addresstoWarehouseModel(ele: SupplierAddressPropertyValues): SupplierWarehouse {
    if (ele) {
      const warehouseAddress = new SupplierWarehouse();
      warehouseAddress.id = ele.warehouseAddressId;
      warehouseAddress.locationName = ele.locationName;
      warehouseAddress.address = ele.street1.newValue;
      warehouseAddress.address2 = ele.street2.newValue;
      warehouseAddress.city = ele.city.newValue;
      warehouseAddress.state = ele.state.newValue;
      warehouseAddress.zipCode = ele.zipCode.newValue;
      warehouseAddress.country = ele.countryCode.newValue;
      return warehouseAddress;
    }
    return null;
  }

  onChangePurpose(event: TslTabChangeEvent) {
    if (event && event.tab.textLabel) {
      this.filterSelection = event.tab.textLabel;
      this.paginationControl.pageIndex = 0;
      this.filterAddress();
      const tabName = this.filterSelection.toLowerCase().split(' ').join('-')
      this.setInternalTab(tabName);
      this.setContactColumn();
      //this.router.navigate([`../${tabName}`], { relativeTo: this.route });

    }
  }

  filterAddress() {
    const tempList = JSON.parse(JSON.stringify(this.addressData));
    this.addressData = this.addressData.filter(x => x.name === this.filterSelection || (x.types && x.types.newValue[0] === this.filterSelection));
    this.loadData();
    this.addressData = JSON.parse(JSON.stringify(tempList));
  }

  onClearFilter() {
    this.filterSelection = "";
    this.loadData();
  }

  isAddressHeader(index, item): boolean {
    // returns if row item is a header
    return item.isGroup;
  }

  checkIfContactAlreadyExists(contactEmail: string): Boolean {
    if (contactEmail) {
      contactEmail = contactEmail.trim();
    }
    return this.contactEmails.some(x => x == contactEmail);
  }

  private onLoadAddressGrouping(): void {
    if (this.supplierAddressList && this.supplierAddressList.length > 0) {
      this.addressData = [];
      if (this.supplierAddressList && this.supplierAddressList.filter(d => d.types.newValue[0] === 'RemitTo').length > 0) {
        this.addressData = this.addressData.concat(this.supplierAddressList.filter(d => d.types.newValue[0] === 'RemitTo'));
      }

      if (this.supplierAddressList && this.supplierAddressList.filter(d => d.types.newValue[0] === 'Manufacturing').length > 0) {
        this.addressData = this.addressData.concat(this.supplierAddressList.filter(d => d.types.newValue[0] === 'Manufacturing'));
      }

      if (this.supplierAddressList &&
        this.supplierAddressList.filter(d => d.types.newValue[0] === 'Off-Site Part Storage Locations').length > 0) {
        this.addressData.push({ isGroup: true, name: 'Off-Site Part Storage Locations' });
        this.addressData = this.addressData.concat(this.supplierAddressList.filter(d => d.types.newValue[0] === 'Off-Site Part Storage Locations'));
      }

      if (this.supplierAddressList &&
        this.supplierAddressList.filter(d => d.types.newValue[0] === 'Supplier Ship From Address').length > 0) {
        this.addressData = this.addressData
          .concat(this.supplierAddressList.filter(d => d.types.newValue[0] === 'Supplier Ship From Address'));
      }

      if (this.supplierAddressList &&
        this.supplierAddressList.filter(d => d.types.newValue[0] === 'External Partner').length > 0) {
        this.addressData.push({ isGroup: true, name: 'External Partner' });
        this.addressData = this.addressData
          .concat(this.supplierAddressList.filter(d => d.types.newValue[0] === 'External Partner'));
      }
      

      this.filterAddress();
    }
  }

  processAddressChanges(newAddress: SupplierAddressPropertyValues, docList: SupplierDocumentPropertyValues[]) {
    if (newAddress) {
      if (docList && docList.length > 0) {
        this.addressModifiedSupplier.documents = [];
        this.addressModifiedSupplier.documents.push(...docList);
      }

      this.addressModifiedSupplier.addresses = [];
      this.addressModifiedSupplier.addresses.push(newAddress);
      this.postEvent(this.addressModifiedSupplier);
    }
  }

  postEvent(eventProperties: SupplierPropertyValue) {
    this.store.dispatch(new PostEvent({
      Name: 'Address Change Requested',
      Properties: this.pickNewValues(eventProperties),
      ReferenceIdentifier: this.SupplierCode
    }));
    this.store.select(SelectEventData).subscribe((evt: any) => {
      if (evt) {
        this.loadComponentData(true);
      }
    });
  }

  pickNewValues(supplierData: SupplierPropertyValue): Supplier {
    if (!supplierData) {
      return null;
    }
    const supplier = new Supplier();

    if (supplierData.addresses) {
      supplier.Addresses = [];
      supplierData.addresses.forEach((address, index) => {
        supplier.Addresses[index] = new SupplierAddress();
        Object.keys(address).forEach(name => {
          supplier.Addresses[index][name] = getNestedNode([name, 'newValue'], address);
        });
        supplier.Addresses[index].Operation = address.operation.newValue ? address.operation.newValue : null;
      });
    }

    if (supplierData.documents) {
      supplier.Documents = [];
      supplierData.documents.forEach((document, index) => {
        supplier.Documents[index] = new SupplierDocument();
        Object.keys(document).forEach(name => {
          supplier.Documents[index][name] = getNestedNode([name, 'newValue'], document);
        });
        supplier.Documents[index].Operation = document.operation.newValue ? document.operation.newValue : null;
      });
    }
    return supplier;
  }

  showHistory() {
    const dialogRef = this.matDialog.open(TabHistoryComponent, {
      width: '90%',
      minWidth: '630px',
      maxHeight: '800px',
      data: { supplierCode: this.SupplierCode, tabName: 'Address' }
    });
  }
}
